<template>
  <div style="margin: 10px 40px 0px">
    <el-form style="margin-right: 30px" :model="addOrgForm" :rules="addOrgRules" ref="addOrgForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="组织名称" prop="name">
        <el-input v-model="addOrgForm.name" placeholder="请输入组织名称"></el-input>
      </el-form-item>
      <el-form-item label="上级组织" prop="orgpid">
        <el-cascader v-fixZoom
          style="width: 100%" :options="orgOptions" v-model="addOrgForm.orgpid" :filterable="true" placeholder="请选择上级组织"
                     :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                     ref="orgOptions" @change="getOrgLevel">
        </el-cascader>
      </el-form-item>
    </el-form>
    <div style="margin-top: 30px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAdd()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddOrg('addOrgForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 30px"></div>
  </div>
</template>

<script>
import {addorg} from '../../../api/organizer'

export default {
  name: 'orgAdd',
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    orgAddRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orgArr: [],
      orgOptions: [],
      addOrgForm: {
        id: 0,
        name: '',
        level: '',
        orgpid: ''
      },
      addOrgRules: {
        name: [
          { required: true, message: '请输入组织名称', trigger: 'blur' }
        ],
        orgpid: [
          { required: true, message: '请选择上级组织', trigger: 'change' }
        ]
      },
      moduletag: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.orgArr = this.orgAddRow.orgArr
    if (this.moduletag === 2) {
      this.getOrTree()
    } else {
      this.orgOptions = this.orgAddRow.orgTree
    }
  },
  mounted () {
  },
  methods: {
    getOrTree () {
      // 所属组织
      let lastLevel = 100
      const arr = []
      for (let i = 0; i < this.orgAddRow.orgArr.length; i++) {
        if (this.orgAddRow.orgArr[i].org_type === 0) {
          arr.push(this.orgAddRow.orgArr[i])
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      let treeData = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          treeData.push(arr[i])
        }
      }
      for (let i = 0; i < treeData.length; i++) {
        const child = this.arrayToNode(arr, treeData[i].id)
        if (child.length !== 0) {
          treeData[i].child = child
        }
      }
      this.orgOptions = treeData
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getOrgLevel (id) {
      let level = ''
      this.orgArr.forEach(item => {
        if (item.id === id) {
          level = item.level + 1
        }
      })
      this.addOrgForm.level = level
      console.log(level)
    },
    submitAddOrg (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addorg(this.addOrgForm).then(res => {
            this.$notify({
              title: '成功',
              message: '成功添加组织',
              type: 'success',
              duration: 2000
            })
            this.golobleObject.updateTableOrg()
            this.$emit('change', false)
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '添加组织失败'
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeAdd () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/orgAdd.vue